export default "__VITE_ASSET__CWMcB60I__"